import { Address, FwVersionContentAndMetadata } from '../dtos/version.dto';
import axiosService from './axios-service';
import { buildAddressPayload } from '../utils/versionUtils';

class AddressService {
    public createAddress = async (customerId: number, sid: number, versionId: string, address: Address): Promise<FwVersionContentAndMetadata> => {
        const result = await axiosService.post(`/api/firewall/customer/${customerId}/service/${sid}/address`,
            {
                ...buildAddressPayload(address),
                externalId: versionId
        });
        return result?.data;
    };

    public updateAddress = async (customerId: number, sid: number, versionId: string,
                                       updatedAddress: Address, originalDisplayName: string): Promise<FwVersionContentAndMetadata> => {
        const result = await axiosService.put(`/api/firewall/customer/${customerId}/service/${sid}/address`, {
            ...buildAddressPayload(updatedAddress),
            id: updatedAddress.id,
            externalId: versionId,
            originalDisplayName,
        });
        return result?.data;
    };

    public deleteAddress = async (customerId: number, sid: number, versionId: string, addressDisplayName: string): Promise<FwVersionContentAndMetadata> => {
        const result = await axiosService.delete(`/api/firewall/customer/${customerId}/service/${sid}/address`, {
            externalId: versionId,
            objectDisplayName: addressDisplayName,
        });
        return result?.data;
    };
}

const addressService = new AddressService();
export default addressService;